export const NEXT_DATA_SET = 200;
export const NEXT_DATA_LOAD_INTERVAL = 500;
export const ZOOM_LEVEL_FOR_IMAGE = 0.2;
export const MIN_NODE_SIZE = 40;
export const MAX_NODE_SIZE = 200;

// disable node node and edges color
export const DISABLE_NODE_AND_EDGES_COLOR = "#3F5678";
// for edges
export const EDGES_BASE_LENGTH = 550;
export const SCALE_FACTOR_EDGES_LENGTH = 60;
export const EDGES_ROUND_VALUE = 0.1;
export const MIN_EDGES_ROUND_VALUE = 0.2;
export const MAX_EDGES_ROUND_VALUE = 0.9;
export const MIN_WIDTH_OF_EDGE = 15;
export const MAX_WIDTH_OF_EDGE = 45;
export const SCALE_FACTOR_OF_EDGE_WIDTH = 5;

// for font
export const BASE_FONT_SIZE = 14;
export const SCALE_FACTOR_FOR_FONT_SIZE = 4;

// for default color set
export const DEFAULT_COLOR_SET = [
  [
    { value: "#ADFF2F", name: "Green Yellow" },
    { value: "#FF7F50", name: "Coral" },
    { value: "#00BFFF", name: "Deep Sky Blue" },
    { value: "#FF1493", name: "Deep Pink" },
  ],
  [
    { value: "#FF6347", name: "Tomato" },
    { value: "#FFD700", name: "Gold" },
    { value: "#40E0D0", name: "Turquoise" },
    { value: "#FF69B4", name: "Hot Pink" },
  ],
  [
    { value: "#FF4500", name: "Orange Red" },
    { value: "#00FA9A", name: "Medium Spring Green" },
    { value: "#FF1493", name: "Deep Pink" },
    { value: "#7FFF00", name: "Chartreuse" },
  ],
];
// Utility function for getting CSS variable values
export const getCSSVariableValue = (variableName) => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(variableName)
    .trim();
};

// Utility function to check if background color is dark
export const checkBackgroundIsDark = (bgColor) => {
  const color = bgColor?.substring(1); // remove the '#'
  const rgb = parseInt(color, 16); // convert rrggbb to decimal
  const r = (rgb >> 16) & 0xff; // extract red
  const g = (rgb >> 8) & 0xff; // extract green
  const b = (rgb >> 0) & 0xff; // extract blue

  const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // calculate luma
  return luma > 160 ? false : true; // return true for dark backgrounds and false for light backgrounds
};
